import { chakra } from '@chakra-ui/react'

export const SearchPanel = chakra('div', {
    baseStyle: ({ theme }) => ({
        border: '4px solid',
        borderColor: theme.palette.search.outerBorderColor,
        borderRadius: '3px',
        padding: '8px',
        backgroundColor: theme.palette.search.inputBgColor,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        position: 'relative',
        _before: {
            display: 'block',
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            border: '1px solid',
            borderColor: theme.palette.search.innerBorderColor,
        },

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            padding: '16px 8px',
        },
    }),
})

export const ROTATED_CLASSNAME = 'rotated'
export const SearchChevron = chakra('button', {
    baseStyle: ({ theme }) => ({
        position: 'relative',
        [`&.${ROTATED_CLASSNAME}`]: {
            transform: 'rotate(180deg)',
        },

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            '& svg': {
                width: '18px',
                height: '18px',
            },
        },
    }),
})

export const SearchResultsFound = chakra('span', {
    baseStyle: ({ theme }) => ({
        color: theme.palette.search.resultsColor,
        fontSize: '14px',
        lineHeight: '21px',
    }),
})
